import React, { useState } from 'react';
import styled from '@emotion/styled';
import type { SpaceProps } from 'styled-system';
import { space } from 'styled-system';

import Alert from 'common/components/Alert';
import { EventBusEvent } from 'common/enums/EventBus';
import { useSubscriptionCallback } from 'common/hooks/subscription';
import type { AlertAction } from 'common/types/alert';

export interface CommonAlertProps extends SpaceProps {
  initialState?: AlertAction;
}

const Wrapper = styled.div<any>`
  ${space};
`;

const CommonAlert = ({ initialState, ...spaceProps }: CommonAlertProps) => {
  const [state, setState] = useState(initialState);

  useSubscriptionCallback(EventBusEvent.ToggleAlert, setState);

  return state && state.isVisible ? (
    <Wrapper data-corgi-id="common-alert" {...spaceProps}>
      <Alert {...state} />
    </Wrapper>
  ) : null;
};

export default CommonAlert;
